import type { SxProps, Theme } from '@mui/material';

export const styles = {
    fields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
    } as SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 1,
        mt: 3,
    } as SxProps<Theme>,
    resendBtn: (theme: Theme): SxProps<Theme> => ({
        textTransform: 'none',
        color: theme.palette.blue[700],
        borderColor: theme.palette.blue[700],
    }),
    cancelBtn: (theme: Theme): SxProps<Theme> => ({
        textTransform: 'none',
        color: theme.palette.red.main,
        borderColor: theme.palette.red.main,
    }),
};
